import Shiroo_B from '../assets/images/team/Shiroo_B.png';
import Umar_FM from '../assets/images/team/Umar_FM.png';
import Hamza_M from '../assets/images/team/Hamza_M.png';
import Miki_B from '../assets/images/team/Miki_B.png';
import Shibz_B from '../assets/images/team/Shibz_B.png';
import Thivolan_M from '../assets/images/team/Thivolan_M.jpg';
import ENEBULA from '../assets/images/team/ENEBULA.jpg';
import Jan_Bond from '../assets/images/team/Jan_Bond.jpg';
import Mo_B from '../assets/images/team/Mo_B.png';
import Science_Defi from '../assets/images/team/Science_Defi.jpg';

export const TeamMembers = [
    {
        name: 'Mo B - Founder and Lead Dev',
        telegram: '@RPMoBoosted',
        twitter: '@Mo_Boosted',
        image: Mo_B
    }, 
    {
        name: 'Shiroo B - Founder',
        telegram: '@shiroogp',
        twitter: '@shiroogp',
        image: Shiroo_B
    }, 
    {
        name: 'Miki B',
        telegram: '@Mrcoupy',
        twitter: '@MikiBcoupe',
        image: Miki_B
    },
    {
        name: 'Shibz B',
        telegram: '@MrSmokey15',
        twitter: '@Momo_Badat',
        image: Shibz_B
    },
]
